
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.5984',
  depVersions: {
  "embedded-viral-link-ui": "static-1.5984",
  "head-dlb": "static-1.4465",
  "hs-test-utils": "static-1.7601",
  "hubspot-dlb": "static-2.1762",
  "HubStyleTokens": "static-2.11057",
  "I18n": "static-7.1519",
  "jasmine-runner": "static-1.6067",
  "quartz": "static-1.6464",
  "quartz-core": "static-1.5683",
  "react-dlb": "static-1.67",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.673",
  "enviro": "static-4.345",
  "foundations-components": "static-1-ak-nestedtablestyle.38",
  "history": "static-4.47",
  "hub-http": "static-1.5820",
  "hubspot-url-utils": "static-1.3810",
  "HubStyle": "static-2.11365",
  "icons": "static-2.601",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6752",
  "PortalIdParser": "static-2.319",
  "quartz-config": "static-1.242",
  "quick-fetch": "static-1.3581",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.16264",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5007",
  "react-virtualized": "static-2.90",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18007",
  "signup-ui-lego-core": "static-1.20017",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.481",
  "ui-addon-react-router-dom": "static-1.9179",
  "ui-images": "static-2.1032",
  "UIComponents": "static-3.8004",
  "usage-tracker": "static-1.6976",
  "usage-tracker-core": "static-1.6826",
  "viral-links-lib": "static-1.6629",
  "hs-promise-rejection-tracking": "static-1.4918",
  "raven": "static-3.5386",
  "raven-hubspot": "static-1.5693",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9277",
  "bend-plugin-trellis-migration": "static-1.3079",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2741",
  "quartz-webpack": "static-1.2688",
  "HeadJS": "static-2.671",
  "framer-motion": "static-1.61",
  "hs-test-utils-bend-plugin": "static-1.2712",
  "msw": "static-1.39",
  "testing-library": "static-1.144",
  "foundations-theming": "static-1.4018",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3941",
  "dispatcher": "static-1.128",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.750",
  "hubspotter-http": "static-1.4305",
  "mobile-manifest-mixins": "static-1.444",
  "quartz-auth": "static-1.139",
  "quartz-head": "static-1.129",
  "quartz-i18n": "static-1.139",
  "quartz-test": "static-1.139",
  "ui-fonts": "static-1.337",
  "sassPrefix": "static-1.148",
  "bend-plugin-foundations-components": "static-1-ak-nestedtablestyle.38",
  "floating-ui": "static-1.49",
  "foundations-assets": "static-1.4443",
  "foundations-theming-specialty": "static-1.1734",
  "hs-story-utils": "static-1.9042",
  "react-aria": "static-1.57",
  "tanstack-table": "static-1.23",
  "trellis-assets": "static-1.874",
  "superstore": "static-1.4384",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4244",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7669",
  "bender-build-tools": "static-1.2729",
  "bend-plugin-foundations-theming": "static-1.2501",
  "foundations-theming-base": "static-1.3003",
  "stylex": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.9052",
  "hubspotter-http-shared-msw-handlers": "static-1.9050",
  "ts-schema": "static-1.3758"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.5984",
  "head-dlb": "/head-dlb/static-1.4465",
  "hs-test-utils": "/hs-test-utils/static-1.7601",
  "hubspot-dlb": "/hubspot-dlb/static-2.1762",
  "HubStyleTokens": "/HubStyleTokens/static-2.11057",
  "I18n": "/I18n/static-7.1519",
  "jasmine-runner": "/jasmine-runner/static-1.6067",
  "quartz": "/quartz/static-1.6464",
  "quartz-core": "/quartz-core/static-1.5683",
  "react-dlb": "/react-dlb/static-1.67",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.673",
  "enviro": "/enviro/static-4.345",
  "foundations-components": "/foundations-components/static-1-ak-nestedtablestyle.38",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5820",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3810",
  "HubStyle": "/HubStyle/static-2.11365",
  "icons": "/icons/static-2.601",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6752",
  "PortalIdParser": "/PortalIdParser/static-2.319",
  "quartz-config": "/quartz-config/static-1.242",
  "quick-fetch": "/quick-fetch/static-1.3581",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.16264",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5007",
  "react-virtualized": "/react-virtualized/static-2.90",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18007",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20017",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9179",
  "ui-images": "/ui-images/static-2.1032",
  "UIComponents": "/UIComponents/static-3.8004",
  "usage-tracker": "/usage-tracker/static-1.6976",
  "usage-tracker-core": "/usage-tracker-core/static-1.6826",
  "viral-links-lib": "/viral-links-lib/static-1.6629",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
  "raven": "/raven/static-3.5386",
  "raven-hubspot": "/raven-hubspot/static-1.5693",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9277",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3079",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2741",
  "quartz-webpack": "/quartz-webpack/static-1.2688",
  "HeadJS": "/HeadJS/static-2.671",
  "framer-motion": "/framer-motion/static-1.61",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2712",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.144",
  "foundations-theming": "/foundations-theming/static-1.4018",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3941",
  "dispatcher": "/dispatcher/static-1.128",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.750",
  "hubspotter-http": "/hubspotter-http/static-1.4305",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.444",
  "quartz-auth": "/quartz-auth/static-1.139",
  "quartz-head": "/quartz-head/static-1.129",
  "quartz-i18n": "/quartz-i18n/static-1.139",
  "quartz-test": "/quartz-test/static-1.139",
  "ui-fonts": "/ui-fonts/static-1.337",
  "sassPrefix": "/sassPrefix/static-1.148",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ak-nestedtablestyle.38",
  "floating-ui": "/floating-ui/static-1.49",
  "foundations-assets": "/foundations-assets/static-1.4443",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1734",
  "hs-story-utils": "/hs-story-utils/static-1.9042",
  "react-aria": "/react-aria/static-1.57",
  "tanstack-table": "/tanstack-table/static-1.23",
  "trellis-assets": "/trellis-assets/static-1.874",
  "superstore": "/superstore/static-1.4384",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4244",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7669",
  "bender-build-tools": "/bender-build-tools/static-1.2729",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2501",
  "foundations-theming-base": "/foundations-theming-base/static-1.3003",
  "stylex": "/stylex/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9052",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9050",
  "ts-schema": "/ts-schema/static-1.3758"
}
};
